@if (hasSession) {
  <span class="prim-quest__label">
    <i class="fa-solid fa-calendar-day"></i>
    {{ 'DASHBOARD.PRIMARY.NEXT_SESSION_LABEL' | translate }}
  </span>
  <h2 class="prim-quest__title">{{ nextSession!.title }}</h2>
  <p class="prim-quest__desc">
    {{ sessionTime }}
    @if (nextSession!.subjectName) { · {{ nextSession!.subjectName }} }
  </p>
  <a class="prim-quest__cta" [routerLink]="agendaLink">
    <i class="fa-solid fa-arrow-right"></i>
    {{ 'DASHBOARD.PRIMARY.NEXT_SESSION_CTA' | translate }}
  </a>
} @else {
  <span class="prim-quest__label">
    <i class="fa-solid fa-bolt-lightning"></i>
    {{ 'DASHBOARD.PRIMARY.QUEST_LABEL' | translate }}
  </span>
  <h2 class="prim-quest__title">{{ 'DASHBOARD.PRIMARY.QUEST_TITLE' | translate }}</h2>
  <p class="prim-quest__desc">{{ 'DASHBOARD.PRIMARY.QUEST_DESC' | translate }}</p>
  <a class="prim-quest__cta" [routerLink]="ctaLink">
    <i class="fa-solid fa-play"></i>
    {{ 'DASHBOARD.PRIMARY.QUEST_CTA' | translate }}
  </a>
}
